export default {
  wrapper: {
    background: '#F4F6F7',
    borderBottom: '1px solid #E4E7EA',
  },
};
